import { Page, UserAgent } from "@repobit/dex-utils";
import { getCurrentDate, getCurrentTime } from '../utils';
import { PageLoadStartedAttributes, PageLoadStartedCompletePageObject, PageLoadStartedInfo } from "./typeDefinitions";

export class PageLoadStartedEvent {
  public event          = 'page load started' as const;
  public pageInstanceID: 'dev' | 'stage' | 'prod';
  public page          : PageLoadStartedCompletePageObject;

  constructor(page: Page, pageInfo: PageLoadStartedInfo, pageAttributes: PageLoadStartedAttributes = {}) {
    this.pageInstanceID = page.environment;

    const [section = '', subSection = '', subSubSection = '', subSubSubSection = ''] = pageInfo.name.split(':');
    const topLevelDomain = window.location.hostname.split('.').splice(1, 2)
      .join('.');
    const referringURL = page.getParamValue('ref') ??
      page.getParamValue('adobe_mc_ref') ??
      document.referrer;

    this.page = {
      info: {
        ...pageInfo,
        section,
        subSection,
        subSubSection,
        subSubSubSection,
        destinationURL: window.location.href,
        queryString   : window.location.search,
        referringURL  : referringURL,
        serverName    : window.location.hostname,
        sysEnv        : UserAgent.os || '',
        language      : page.locale
      },
      attributes: {
        internalPromotionID: page.getParamValue('icid') || '',
        trackingID         : page.getParamValue('cid') || '',
        time               : getCurrentTime(),
        date               : getCurrentDate(),
        domain             : topLevelDomain,
        domainPeriod       : window.location.hostname.split('.').length - 1,
        ppvScrollData      : sessionStorage.getItem('ppvScrollData') || '',
        ppvName            : sessionStorage.getItem('ppvName') || '',
        ...pageAttributes
      }
    };
  }
}
